import React from "react";
import Modal from "../Common/Modal";
import MtiButton from "../Buttons/MtiButton";

type Props = {
  show: boolean;
  onHide: () => void;
  onClickSwitch: () => void;
};

export default function BlockRouteOnAutoModeModal({ show, onHide, onClickSwitch }: Props) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={false}
      style={{
        width: 686,
        minHeight: 422,
        color: "#000000",
      }}
    >
      <Modal.Header
        title="Change Mode Confirmation"
        hideButtonEnabled={false}
        style={{
          marginBottom: 3,
          flexGrow: 0,
          flexShrink: 0,
        }}
      ></Modal.Header>
      <Modal.Body>
        <svg
          width="71"
          height="71"
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.5 70.0833C54.5998 70.0833 70.0833 54.5998 70.0833 35.5C70.0833 16.4001 54.5998 0.916626 35.5 0.916626C16.4002 0.916626 0.916668 16.4001 0.916668 35.5C0.916668 54.5998 16.4002 70.0833 35.5 70.0833ZM28.5833 7.83329L32.0417 42.4166H38.9583L42.4167 7.83329H28.5833ZM35.5 63.1666C39.32 63.1666 42.4167 60.0699 42.4167 56.25C42.4167 52.43 39.32 49.3333 35.5 49.3333C31.68 49.3333 28.5833 52.43 28.5833 56.25C28.5833 60.0699 31.68 63.1666 35.5 63.1666Z"
            fill="#F7A246"
          />
        </svg>

        <div
          style={{
            marginTop: 43,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: 20,
            letterSpacing:0.15,
            color: "#414042",
          }}
        >
          You are on Auto Mode, switch Manual Mode to continue
        </div>
        <p
          style={{
            marginTop: 12,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: 15,
            textAlign: "center",
            letterSpacing: 0.5,
            color: "#888888",
          }}
        >
          When you switch it, all your schedule will be postponed until switch
          back to Auto Mode
        </p>
      </Modal.Body>
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          columnGap: 16,
          marginBottom: 21,
          marginRight: 15,
        }}
      >
        <MtiButton
          size="large"
          style={{
            width: 157,
          }}
          onClick={onClickSwitch}
        >
          Switch
        </MtiButton>
        <MtiButton
          size="large"
          variant="secondary"
          style={{
            width: 157,
          }}
          onClick={onHide}
        >
          Cancel
        </MtiButton>
      </div>
    </Modal>
  );
}
